import { create } from "zustand";

const initialState = {
  selectedBomIds: [],
  certifier: null,
  exporter: null,
  importer: null,
  producerDataType: null,
  producers: [],
};

const useCertificateOfOriginStore = create((set) => ({
  ...initialState,
  setSelectedBomIds: (payload) => {
    set({ selectedBomIds: payload });
  },
  setCertifier: (payload) => {
    set({ certifier: payload });
  },
  setExporter: (payload) => {
    set({ exporter: payload });
  },
  setImporter: (payload) => {
    set({ importer: payload });
  },
  setProducerDataType: (payload) => {
    set({ producerDataType: payload });
  },
  setProducers: (payload) => {
    set({ producers: payload });
  },
  clear: () => {
    set({ ...initialState });
  },
}));

export default useCertificateOfOriginStore;
